<div class="tile-padding-first tile-padding">
  @if (filtersEnabled) {
    <!-- The same layout as the Reports tab: every filter in the bar, and the list follows the filters as they settle. -->
    <form [formGroup]="frmReportSent">
      <div class="flex-search-container filter-bar">
        <div class="filter-bar__group">
          <div class="filter-bar__field">
            <div class="filter-bar__label">Report Types</div>
            <app-searchable-select formControlName="reports" [items]="reportDataService.reports"
              displayField="name" placeholder="All report types"
              searchPlaceholder="Search report types…"></app-searchable-select>
          </div>
          <div class="filter-bar__field">
            <div class="filter-bar__label">Client</div>
            <app-searchable-select formControlName="clients" [items]="reportDataService.clientList"
              displayField="dropdownDisplay" valueField="clientId" placeholder="All clients"
              searchPlaceholder="Search clients…" (selectionChange)="onClientSelected($event)"></app-searchable-select>
          </div>
          <div class="filter-bar__field">
            <div class="filter-bar__label">Start Date</div>
            <input type="date" class="field__control" formControlName="startDate" required (input)="datePreset = null"
              title="Please select a start date">
            @if (frmReportSent.controls.startDate.invalid && frmReportSent.controls.startDate.touched) {
              <span class="field__error">Enter Start Date</span>
            }
          </div>
          <div class="filter-bar__field">
            <div class="filter-bar__label">End Date</div>
            <input type="date" class="field__control" formControlName="endDate" required (input)="datePreset = null"
              title="Please select an end date">
            @if (frmReportSent.controls.endDate.invalid && frmReportSent.controls.endDate.touched) {
              <span class="field__error">Enter End Date</span>
            }
          </div>
          <div class="filter-bar__field">
            <div class="filter-bar__label">Tuition Coordinator</div>
            <app-searchable-select formControlName="coordinators" [items]="reportDataService.coordinatorList"
              displayField="name" valueField="id" placeholder="Select a tuition coordinator"
              searchPlaceholder="Search coordinators…"></app-searchable-select>
            <app-report-lookup-note lookup="coordinators" label="coordinators"></app-report-lookup-note>
          </div>
          <div class="filter-bar__field">
            <div class="filter-bar__label">Tutors</div>
            <app-searchable-select formControlName="tutors" [items]="reportDataService.tutorList"
              displayField="name" valueField="id" placeholder="Select a tutor"
              searchPlaceholder="Search tutors…"></app-searchable-select>
            <app-report-lookup-note lookup="tutors" label="tutors"></app-report-lookup-note>
          </div>
          <div class="filter-bar__field">
            <div class="filter-bar__label">Learners</div>
            <app-searchable-select formControlName="students" [items]="reportDataService.studentList"
              displayField="name" valueField="name" placeholder="Select a learner"
              searchPlaceholder="Search learners…"></app-searchable-select>
            <app-report-lookup-note lookup="students" label="learners"></app-report-lookup-note>
          </div>
          <app-brand-filter class="filter-bar__field" [companyIds]="companyIds"
            (companyIdsChange)="companyIds = $event; filtersChanged()"></app-brand-filter>
          <div class="filter-bar__field" data-filter="recipient">
            <div class="filter-bar__label">Recipient</div>
            <app-typeahead [ngModel]="recipient" (ngModelChange)="recipient = $event; filtersChanged()"
              [ngModelOptions]="{ standalone: true }" placeholder="Email contains"
              [enabled]="autocompleteEnabled" [source]="recipientEmails"></app-typeahead>
          </div>
          <div class="filter-bar__field" data-filter="delivery">
            <label class="filter-bar__label" for="deliveryStatusFilter">Delivery</label>
            <select id="deliveryStatusFilter" class="field__control" [ngModel]="deliveryStatus"
              (ngModelChange)="deliveryStatus = $event; filtersChanged()" [ngModelOptions]="{ standalone: true }"
              title="Failed and opted-out lines show only when picked here">
              @for (option of deliveryOptions; track option.value) {
                <option [ngValue]="option.value">{{option.label}}</option>
              }
            </select>
          </div>
        </div>
        <div class="filter-bar__actions">
          <div class="filter-bar__presets">
            <app-date-presets [selected]="datePreset" (presetSelected)="onDatePreset($event)"></app-date-presets>
          </div>
          <div class="filter-bar__buttons">
            <app-filter-clear-all (clear)="clearAll()"></app-filter-clear-all>
          </div>
        </div>
      </div>
    </form>
  } @else {
    <form [formGroup]="frmReportSent">
      <div class="flex-search-container" [class.filter-bar]="filtersEnabled">
        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group">
          <div fxLayout.gt-md="column" class="filter-bar__field">
            <div class="filter-bar__label">Start Date</div>
            <input type="date" class="field__control" formControlName="startDate" required (input)="datePreset = null"
              data-toggle="tooltip" data-placement="top" title="Please select a start date">
            @if (frmReportSent.controls.startDate.invalid && frmReportSent.controls.startDate.touched) {
              <span class="field__error">Enter Start Date</span>
            }
            </div>
            <div fxLayout.gt-md="column" class="filter-bar__field">
              <div class="filter-bar__label">End Date</div>
              <input type="date" class="field__control" formControlName="endDate" required (input)="datePreset = null"
                data-toggle="tooltip" data-placement="top" title="Please select an end date">
              @if (frmReportSent.controls.endDate.invalid && frmReportSent.controls.endDate.touched) {
                <span class="field__error">Enter End Date</span>
              }
              </div>
              <div fxLayout.gt-md="column" class="filter-bar__field">
                <div class="filter-bar__label">Report Types</div>
                <app-searchable-select formControlName="reports" [items]="reportDataService.reports"
                  displayField="name" placeholder="Select a report type"
                  searchPlaceholder="Search report types…"></app-searchable-select>
              </div>
              <ng-container *appFeatureSwitch="filtersKey">
                <div fxLayout.gt-md="column" class="filter-bar__group">
                  <app-brand-filter class="filter-bar__field" [(companyIds)]="companyIds"></app-brand-filter>
                </div>
                <div fxLayout.gt-md="column" class="filter-bar__field" data-filter="recipient">
                  <div class="filter-bar__label">Recipient</div>
                  <app-typeahead [(ngModel)]="recipient" [ngModelOptions]="{ standalone: true }"
                    placeholder="Email contains" (keyup.enter)="filterReports()"
                    [enabled]="autocompleteEnabled" [source]="recipientEmails"></app-typeahead>
                </div>
                <div fxLayout.gt-md="column" class="filter-bar__field" data-filter="delivery">
                  <label class="field__label" for="deliveryStatusFilter">Delivery</label>
                  <select id="deliveryStatusFilter" class="field__control" [(ngModel)]="deliveryStatus" [ngModelOptions]="{ standalone: true }"
                    title="Failed and opted-out lines show only when picked here">
                    @for (option of deliveryOptions; track option.value) {
                      <option [ngValue]="option.value">{{option.label}}</option>
                    }
                  </select>
                </div>
              </ng-container>
              @if (!filtersEnabled) {
                <div fxLayout.gt-md="column">
                  <div class="btn-align">
                    <span class="div-padding-right-10"><button class="btn btn-primary" name="View" value="View" (click)="filterReports()">Filter</button></span>
                  </div>
                </div>
              }
            </div>
            @if (filtersEnabled) {
              <div class="filter-bar__actions">
                <div class="filter-bar__presets">
                  <app-date-presets [selected]="datePreset" (presetSelected)="onDatePreset($event)"></app-date-presets>
                </div>
                <div class="filter-bar__buttons">
                  <app-filter-clear-all (clear)="clearAll()"></app-filter-clear-all>
                  <button class="btn btn-primary" name="View" value="View" (click)="filterReports()">Filter</button>
                </div>
              </div>
            }
          </div>
          <mat-expansion-panel hideToggle="true" class="custom-header" [expanded]="false">
            <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
              <mat-panel-title>
                More Options
              </mat-panel-title>
              <mat-panel-description>
                &nbsp;
                <mat-icon>
                  <i class="tw:ml-2">
                    <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="sliders-h" role="img"
                      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-sliders-h fa">
                      <path fill="currentColor"
                        d="M504 384H192v-40c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88v40c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-40h312c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-344 64h-32v-96h32v96zM504 96H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h152v40c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-40h248c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-280 64h-32V64h32v96zm280 80h-88v-40c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h312v40c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-40h88c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-120 64h-32v-96h32v96z"
                      class=""></path>
                    </svg>
                  </i>
                </mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="flex-search-container">
              <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub">
                <div fxLayout.gt-md="column">
                  <div>Clients</div>
                  <app-searchable-select formControlName="clients" [items]="reportDataService.clientList"
                    displayField="dropdownDisplay" valueField="clientId" placeholder="Select a client"
                    searchPlaceholder="Search clients…" (selectionChange)="onClientSelected($event)"></app-searchable-select>
                </div>
                <div fxLayout.gt-md="column">
                  <div>Tuition Coordinator</div>
                  <app-searchable-select formControlName="coordinators" [items]="reportDataService.coordinatorList"
                    displayField="name" valueField="id" placeholder="Select a tuition coordinator"
                    searchPlaceholder="Search coordinators…"></app-searchable-select>
                  <app-report-lookup-note lookup="coordinators" label="coordinators"></app-report-lookup-note>
                </div>
                <div fxLayout.gt-md="column">
                  <div>Tutors</div>
                  <app-searchable-select formControlName="tutors" [items]="reportDataService.tutorList"
                    displayField="name" valueField="id" placeholder="Select a tutor"
                    searchPlaceholder="Search tutors…"></app-searchable-select>
                  <app-report-lookup-note lookup="tutors" label="tutors"></app-report-lookup-note>
                </div>
                <div fxLayout.gt-md="column">
                  <div>Learners</div>
                  <app-searchable-select formControlName="students" [items]="reportDataService.studentList"
                    displayField="name" valueField="name" placeholder="Select a learner"
                    searchPlaceholder="Search learners…"></app-searchable-select>
                  <app-report-lookup-note lookup="students" label="learners"></app-report-lookup-note>
                </div>
                <div fxLayout.gt-md="column">
                  <div class="tw:invisible">&nbsp;</div>
                  <span><button class="btn btn-primary" type="button" name="View" value="View" (click)="clearMoreOptions()">Clear filters</button></span>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </form>
  }
    </div>
    <label class="tw:text-danger">{{errorMsg}}</label>
    @if (hasSearched) {
      <app-data-table
        [columns]="columns"
        [data]="reportRows"
        [showView]="true"
        [serverSide]="true"
        [totalCount]="totalCount"
        [loading]="loading"
        [sortField]="sortField"
        [sortDir]="sortDir"
        [tableId]="tableId"
        emptyMessage="No reports found"
        (rowAction)="onRowAction($event)"
        (pageChange)="onPageChange($event)"
        (sortChange)="onSortChange($event)">
        <ng-template appColumnCell="deliveryStatus" let-row>
          <span class="delivery-status" [attr.data-delivery]="row.deliveryStatus" [title]="deliveryDetail(row)">
            <app-status-pill [label]="deliveryLabel(row)" [variant]="deliveryVariant(row)"></app-status-pill>
          </span>
          @if (row.deliveryStatus === 'Failed' || row.deliveryStatus === 'NotSent') {
            @if (row.failureReason) {
              <div class="delivery-status__reason">{{row.failureReason}}</div>
            }
          }
        </ng-template>
      </app-data-table>
    }
    <label class="tw:text-danger">{{errorMsg}}</label>
    @if (reportSelected) {
      <div class="tw:container tw:mx-auto">
        <iframe [src]="selectedReportUrl | safe" frameborder="0" allowfullscreen="true" class="responsive-iframe"></iframe>
      </div>
    }